/** @format */

import Spine from './icon/Spine.png'
import Spine_hover from './icon/Spine_hover.png'
import Spine_click from './icon/Spine_click.png'
import ServerLeaf from './icon/ServerLeaf.png'
import ServerLeaf_hover from './icon/ServerLeaf_hover.png'
import ServerLeaf_click from './icon/ServerLeaf_click.png'
import SuperSpine from './icon/SuperSpine.png'
import SuperSpine_hover from './icon/SuperSpine_hover.png'
import SuperSpine_click from './icon/SuperSpine_click.png'
// 节点类型对应图标
export const nodeImg = {
  Spine: Spine,
  SuperSpine: SuperSpine,
  ServerLeaf: ServerLeaf
}
export const nodeHoverImg = {
  Spine: Spine_hover,
  SuperSpine: SuperSpine_hover,
  ServerLeaf: ServerLeaf_hover
}
export const nodeActiveImg = {
  Spine: Spine_click,
  SuperSpine: SuperSpine_click,
  ServerLeaf: ServerLeaf_click
}

// 设备状态
export const nodeStatus = {
  0: '未管理',
  1: '正常',
  2: '离线',
  3: '未知',
  4: 'SNMP不可达'
}
// 接口状态
export const portStatus = {
  11: 'up',
  12: 'down'
}
export const portStatusColor = {
  11: '#36B42A',
  12: '#ddd'
}

// 链路信息

export const edgeTabelData = [
  {
    name: '名称',
    source: '',
    desination: ''
  },
  {
    name: 'IP',
    source: '',
    desination: ''
  },
  {
    name: '角色',
    source: '',
    desination: ''
  },
  {
    name: '端口',
    source: '',
    desination: ''
  }
  //   {
  //     name: '接收带宽占用率',
  //     source: '',
  //     desination: ''
  //   },
  //   {
  //     name: '接收速率',
  //     source: '',
  //     desination: ''
  //   },
  //   {
  //     name: '发送带宽占用率',
  //     source: '',
  //     desination: ''
  //   },
  //   {
  //     name: '发送速率',
  //     source: '',
  //     desination: ''
  //   }
]

// 向上取整保留两位小数
export const handleUsageNum = number => {
  let result = Math.ceil(number * 100) / 100
  result = parseFloat(result.toFixed(2))
  return result
}
